import { makeStyles } from '@material-ui/core';
import { Colors } from '../../utils';

const makeClasses = makeStyles(theme => ({
  alert: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)} !important`,
    width: '100%',
    boxSizing: 'border-box',
    marginBottom: theme.spacing(2),

    '& > div': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  alertWithNoIcon: {
    padding: `${theme.spacing(2)} ${theme.spacing(4)} !important`,
  },
  alertTitle: {
    fontFamily: theme.fontFamily.regular,

    '& strong': {
      fontFamily: theme.fontFamily.bold,
    },
  },
  alertMessage: {
    marginBottom: 7,
  },
  alertButton: {
    display: 'inline-block',
    background: Colors.rgb.alertWarningText,
    color: Colors.rgb.alertWarningBackground,
    border: 'none',
    borderRadius: 5,
    padding: `7px ${theme.spacing(2)}`,
    cursor: 'pointer',

    '&:hover': {
      background: Colors.rgba(Colors.rgb.alertWarningText, 90),
    },
  },
  alertIcon: {
    fontSize: 30,
    padding: 5,
    marginRight: theme.spacing(2),
    borderRadius: 40,
    border: `3px solid ${Colors.rgb.alertWarningText}`,
  },
  alertSuccess: {
    background: Colors.rgb.alertSuccessBackground,
    border: `1px solid ${Colors.rgb.alertSuccessBorder}`,
    color: `${Colors.rgb.alertSuccessText} !important`,
  },
  alertWarning: {
    background: Colors.rgb.alertWarningBackground,
    border: `1px solid ${Colors.rgb.alertWarningBorder}`,
    color: `${Colors.rgb.alertWarningText} !important`,
  },
  alertError: {
    background: Colors.rgb.alertDangerBackground,
    border: `1px solid ${Colors.rgb.alertDangerBorder}`,
    color: `${Colors.rgb.alertDangerText} !important`,
  },
}));

export default makeClasses;
